import { useFormContext } from "react-hook-form";
import { InputOTP, type InputOTPProps, cn } from "ui";
import { useField } from "../hooks/useField";
import { useFormFieldContext } from "./FormField";

type InputFormFieldProps = Omit<
  InputOTPProps,
  "value" | "onChange" | "id" | "name"
>;

export function InputOTPFormField({
  className,
  slotClassName,
  ...props
}: InputFormFieldProps) {
  const {
    name,
    disabled,
    readOnly,
    required,
    defaultValue,
    validation,
    customValidation,
    descriptionId,
    errorMessageId,
    shouldUnregister,
  } = useFormFieldContext();

  const { ref, value, onChange, onBlur, error } = useField({
    name,
    defaultValue,
    validation,
    customValidation,
    shouldUnregister,
  });

  return (
    <InputOTP
      ref={ref}
      value={value}
      onChange={onChange}
      className={className}
      slotClassName={cn(
        slotClassName,
        error && "!border-danger-bold !ring-danger-bold bg-danger-subtler"
      )}
      onBlur={onBlur}
      {...props}
    />
  );
}
